module.exports = __webpack_public_path__ + "img/downloadApp10.131f677c.svg";